import { Component, Input, HostBinding, ChangeDetectionStrategy } from "@angular/core";

import { Task } from "../../../shared/types";

@Component({
	selector: "ic-task-item",
	templateUrl: "./task-item.component.html",
	styleUrls: ["./task-item.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TaskItemComponent {
	// @ts-expect-error TS2564
	@HostBinding("class.previous") previous: boolean;
	// @ts-expect-error TS2564
	@HostBinding("class.disabled") isDisabled: boolean;

	// @ts-expect-error TS2564
	@Input() task: Task;
	// @ts-expect-error TS2564
	@Input() shiftId: number;
	// @ts-expect-error TS2564
	@Input() hasUpdatePermission: boolean;

	@Input() set current(value: boolean) {
		this.previous = !value;
	}
	@Input() set enabled(value: boolean) {
		this.isDisabled = !value;
	}
}
